 <template>
    <div>
        <div v-for="(filter, index) in selectedFilters">
            {{ index }}: {{ filter.join(', ') }}
        </div>
        <hr/>
        <div v-for="(profile, index) in profiles">
            {{ profile.first_name }} {{ profile.last_name }}
            <br/>
            <div>
                competencies: {{ profile.filter_competencies.join(', ') }}
            </div>
            <div>
                industry_sectors: {{ profile.filter_industry_sectors.join(', ') }}
            </div>
            <div>
                regions: {{ profile.filter_regions.join(', ') }}
            </div>
            <div>
                languages: {{ profile.filter_languages.join(', ') }}
            </div>
            <div>
                company-sizes: {{ profile.filter_company_sizes.join(', ') }}
            </div>
            <div>
                education: {{ profile.filter_education.join(', ') }}
            </div>
            <hr>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        profiles: {
            type: Array,
            required: false,
        },
        selectedFilters: {
            type: Object,
            required: false,
        },
    },
}
</script>
